import type { ColumnVisibilityItem } from "providers/Auth";

export const sortableKeys = [
  "screening_status",
  "status",
  "submitted_at",
  "started_at",
  "updated_at",
  "applicants",
  "desired_move_in_date",
  "property",
  "state",
  "unit",
  "last_note",
  "stage",
  "property_group",
  "assigned_to",
  "unit_type"
];

export const DEFAULT_PER_PAGE = window.localStorage.getItem("per_page") || "10";

export const SESSION_STORAGE_KEY = "applications_table_query_params";

export const NO_UNIT_TYPE = "no_unit_type";

export const URL_PARAM_KEYS = [
  "search",
  "page",
  "tab",
  "per_page",
  "status",
  "properties",
  "cities",
  "units",
  "unit_types",
  "screening_statuses",
  "sort_by",
  "sort_dir",
  "group_by",
  "unit_status",
  "assignee_ids",
  "property_group_ids",
  "stage_ids",
  "states",
  "submitted_at_from",
  "submitted_at_to",
  "started_at_from",
  "started_at_to",
  "updated_at_from",
  "updated_at_to",
  "desired_move_in_date_from",
  "desired_move_in_date_to"
] as const;

export const DEFAULT_URL_PARAMS: Record<string, string> = {
  search: "",
  page: "",
  tab: "",
  per_page: "",
  status: "",
  properties: "",
  cities: "",
  units: "",
  unit_types: "",
  screening_statuses: "",
  sort_by: "",
  sort_dir: "",
  group_by: "",
  unit_status: "",
  assignee_ids: "",
  property_group_ids: "",
  stage_ids: "",
  states: "",
  submitted_at_from: "",
  submitted_at_to: "",
  started_at_from: "",
  started_at_to: "",
  updated_at_from: "",
  updated_at_to: "",
  desired_move_in_date_from: "",
  desired_move_in_date_to: ""
};

// Boom's standard order for the Applications table, matching the API's
// Boom::Partner::User::APPLICATIONS_DEFAULT_COLUMNS id for id (CRM-1891): a saved list still in
// this order counts as never reordered, so new columns slot into their standard place.
export const DEFAULT_COLUMN_VISIBILITY: ColumnVisibilityItem[] = [
  { id: "criteria", label: "Criteria", checked: true, disabled: false },
  { id: "applicants", label: "Applicants", checked: true, disabled: false },
  { id: "property", label: "Property", checked: true, disabled: false },
  { id: "state", label: "State", checked: false, disabled: false },
  {
    id: "property_group",
    label: "Property group",
    checked: false,
    disabled: false
  },
  { id: "unit", label: "Unit", checked: true, disabled: false },
  { id: "unit_type", label: "Unit type", checked: false, disabled: false },
  {
    id: "started_at",
    label: "Started Date/Time",
    checked: true,
    disabled: false
  },
  { id: "last_note", label: "Last note", checked: false, disabled: false },
  {
    id: "submitted_at",
    label: "Submitted Date/Time",
    checked: true,
    disabled: false
  },
  {
    id: "desired_move_in_date",
    label: "Move-in date",
    checked: false,
    disabled: false
  },
  { id: "updated_at", label: "Updated at", checked: false, disabled: false },
  { id: "assigned_to", label: "Assigned to", checked: true, disabled: false },
  { id: "status", label: "Status", checked: true, disabled: false },
  { id: "stage", label: "Stage", checked: true, disabled: false },
  // Message icon column, fixed to the right edge; off until a user turns it on (CRM-1133).
  { id: "chat", label: "Chat", checked: false, disabled: false }
];
